import { protectRoutes } from 'components/desktop/_general/ProtectedRoute/ProtectedRoute';
import Reports from 'containers/desktop/Reports/Index';

const protectedRoutes = [
	{
		path: '/reports',
		element: <Reports />,
		permissions: [],
	},
];

export default [...protectRoutes(protectedRoutes)];
